<script setup>
import { computed, ref } from 'vue';
import { useStore, useStoreGetters } from 'dashboard/composables/store';
import { useI18n } from 'vue-i18n';
import { useAlert } from 'dashboard/composables';

import Dialog from 'next/dialog/Dialog.vue';

const { t } = useI18n();
const store = useStore();
const getters = useStoreGetters();

const provider = ref({});
const dialogRef = ref(null);
const uiFlags = getters['wgptSamlProviders/getUIFlags'];

const description = computed(() => {
  return `${t('WGPT_SAML.PROVIDERS.DELETE.CONFIRM.MESSAGE')} ${provider.value.displayName}?`;
});

const handleDialogConfirm = async () => {
  const id = provider.value.id;
  if (!id) return;

  try {
    await store.dispatch('wgptSamlProviders/delete', id);
    useAlert(t('WGPT_SAML.PROVIDERS.DELETE.API.SUCCESS_MESSAGE'));
  } catch (error) {
    useAlert(t('WGPT_SAML.PROVIDERS.DELETE.API.ERROR_MESSAGE'));
  } finally {
    dialogRef.value?.close();
  }
};

const open = selectedProvider => {
  provider.value = selectedProvider;
  dialogRef.value?.open();
};

defineExpose({ open });
</script>

<template>
  <Dialog
    ref="dialogRef"
    type="alert"
    :title="t('WGPT_SAML.PROVIDERS.DELETE.CONFIRM.TITLE')"
    :description="description"
    :confirm-button-label="t('WGPT_SAML.PROVIDERS.DELETE.CONFIRM.YES')"
    :cancel-button-label="t('WGPT_SAML.PROVIDERS.DELETE.CONFIRM.NO')"
    :is-loading="uiFlags.isDeleting"
    :disable-confirm-button="uiFlags.isDeleting"
    @confirm="handleDialogConfirm"
  />
</template>
